import React from 'react';

export default () => <div className="container-fluid">
    <h4>Pax calls</h4>
</div>